/**
 * The Fidèle finish switch (brand/WEBSITE_DESIGN_v1.md § 2.4): one control shows every card on
 * the page in Yellow or White, and each card's link opens that finish. The choice lives for the
 * browser session only (sessionStorage) and applies only on pages that carry the switch, so a page
 * without one (the homepage, Issue 01, Stacks, Gifts, a product page) always shows Yellow and never
 * a finish the visitor cannot switch back there. With storage blocked the switch still works per page.
 */
const KEY = 'fidele-finish';

function apply(finish, persist = true) {
  const value = finish === 'White' ? 'White' : 'Yellow';
  if (value === 'White') document.documentElement.dataset.finish = 'White';
  else delete document.documentElement.dataset.finish;

  for (const button of document.querySelectorAll('[data-finish-switch] button[data-value]')) {
    button.setAttribute('aria-pressed', String(button.dataset.value === value));
  }
  for (const link of document.querySelectorAll('a[data-url-white]')) {
    const href = value === 'White' ? link.dataset.urlWhite : link.dataset.urlYellow;
    if (href) link.setAttribute('href', href);
  }
  if (!persist) return;
  try {
    window.sessionStorage.setItem(KEY, value);
  } catch {
    // Storage blocked: the page still switches.
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target.closest('[data-finish-switch] button[data-value]') : null;
  if (!(target instanceof HTMLElement)) return;
  apply(target.dataset.value || 'Yellow');
});

let start = 'Yellow';
if (document.querySelector('[data-finish-switch]')) {
  try {
    start = window.sessionStorage.getItem(KEY) || 'Yellow';
  } catch {
    start = 'Yellow';
  }
}
apply(start, false);
